export default __webpack_public_path__ + "static/media/ecran_ordi_no_background.1aa8b3ce.png";